export var MFCategories;
(function (MFCategories) {
    MFCategories["EQUITY"] = "Equity";
    MFCategories["HYBRID"] = "Hybrid";
    MFCategories["DEBT"] = "Debt";
    MFCategories["OTHERS"] = "Other";
})(MFCategories || (MFCategories = {}));
export var MFCategoriesCode;
(function (MFCategoriesCode) {
    MFCategoriesCode[MFCategoriesCode["EQUITY"] = 1] = "EQUITY";
    MFCategoriesCode[MFCategoriesCode["HYBRID"] = 3] = "HYBRID";
    MFCategoriesCode[MFCategoriesCode["DEBT"] = 2] = "DEBT";
    MFCategoriesCode[MFCategoriesCode["OTHERS"] = 5] = "OTHERS";
    MFCategoriesCode[MFCategoriesCode["SOLUTION_ORIENTED"] = 4] = "SOLUTION_ORIENTED";
})(MFCategoriesCode || (MFCategoriesCode = {}));
export var MFSchemsPlanes;
(function (MFSchemsPlanes) {
    MFSchemsPlanes["GROWTH"] = "Growth";
    MFSchemsPlanes["IDCW"] = "Dividend";
    MFSchemsPlanes["DIVIDEND_PAYOUT"] = "DividendPayout";
    MFSchemsPlanes["DIVIDEND_INVESTMENT"] = "DividendInvenstment";
})(MFSchemsPlanes || (MFSchemsPlanes = {}));
export var MFSchemesPlanTypes;
(function (MFSchemesPlanTypes) {
    MFSchemesPlanTypes["REGULAR"] = "Regular";
    MFSchemesPlanTypes["DIRECT"] = "Direct";
})(MFSchemesPlanTypes || (MFSchemesPlanTypes = {}));
export var EMFSchemesPlanType2;
(function (EMFSchemesPlanType2) {
    EMFSchemesPlanType2["NORMAL"] = "NORMAL";
    EMFSchemesPlanType2["DIRECT"] = "DIRECT";
})(EMFSchemesPlanType2 || (EMFSchemesPlanType2 = {}));
export var MorningStarRatings;
(function (MorningStarRatings) {
    MorningStarRatings[MorningStarRatings["RATING_FIVE"] = 5] = "RATING_FIVE";
    MorningStarRatings[MorningStarRatings["RATING_FOUR"] = 4] = "RATING_FOUR";
    MorningStarRatings[MorningStarRatings["RATING_THREE"] = 3] = "RATING_THREE";
    MorningStarRatings[MorningStarRatings["RATIING_TWO"] = 2] = "RATIING_TWO";
    MorningStarRatings[MorningStarRatings["RATING_ONE"] = 1] = "RATING_ONE";
})(MorningStarRatings || (MorningStarRatings = {}));
export var AUMFundSize;
(function (AUMFundSize) {
    AUMFundSize[AUMFundSize["AUM_300_CR"] = 300] = "AUM_300_CR";
    AUMFundSize[AUMFundSize["AUM_200_CR"] = 200] = "AUM_200_CR";
    AUMFundSize[AUMFundSize["AUM_100_CR"] = 100] = "AUM_100_CR";
})(AUMFundSize || (AUMFundSize = {}));
export var catCodes = {
    "equity funds": "1",
    debt: "2",
    "hybrid funds": "3",
    "solution oriented": "4",
    others: "5",
};
